import { Result } from "@praha/byethrow"
import { createServerFn } from "@tanstack/react-start"
import { getNotifications as getNotificationsService } from "@apps/gwservice/notifications"
import { withAuth } from "~/features/auth/server/auth"

export const getNotifications = createServerFn({
  method: "GET",
})
  .inputValidator((data: { page?: number }) => data)
  .handler(({ data }) =>
    Result.try({
      try: () => withAuth(getNotificationsService)(data.page),
      catch: () => "unexpected server error",
    }),
  )
